import {saveAs} from 'file-saver';
import {getFormConfig,processResponse,responseBlob,basesubmit} from './helpers';

export const jsonpost = async(url:string,json:any) => {
  try{
    const config:any = {
      method:'POST',
      credentials:'include',
      body:JSON.stringify(json),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    };
    const resp = await fetch(url,config);
    const response = await resp.json();
    const {error,data} = processResponse(response);
    if(error) return Promise.reject(data);
    else return data;
  }
  catch(err){
    return Promise.reject(err);
  }
};

export const bizpost = async(json:any) => jsonpost('/biz',json);

////
export const bizfile = async (url:string,json:any,filename:string,type:any,ext:any) => {
  try{
    const config:any = {
      method:'POST',
      credentials:'include',
      body:JSON.stringify(json), 
      headers: new Headers({
        'Content-Type': 'application/json', //TODO: Accept application/*
      })
    };
    const resp = await fetch(url,config);
    console.log('bizfile.status: ',resp.status);
    console.log('bizfile.statusText: ',resp.statusText);
    console.log('bizfile.ok: ',resp.ok);
    console.log('bizfile.headers: ',JSON.stringify(resp.headers));
    if(!resp.ok){
      //const {success,message} = resp.json();
      const err:any = await resp.text();
      console.log('bizfile.resp.error:',err);
      return Promise.reject(err.message||err||'request failed...');
    }
    const blob = await resp.blob();
    console.log('url: ',url);
    console.log('filename: ',filename);
    console.log('type: ',type);
    console.log('ext: ',ext);
    const {error,success} = responseBlob(blob,ext,type,filename);
    if(error) return Promise.reject(error);
    return success;
  }
  catch(error){
    console.log('bizfile.error: ',error);
    return Promise.reject(error);
  }
};

export const bizpdf = async (url:string,json:any,filename:string) => {
  try{
    return bizfile(url,json,filename,'pdf','application/pdf');
  }
  catch(err){
    return Promise.reject(err);
  }
};

export const bizzip = async (url:string,json:any,filename:string) =>{
  try{
    return bizfile(url,json,filename,'zip','application/zip');
  }
  catch(err){
    return Promise.reject(err);
  }
};

export const bizdownload = async (meta:any,url:string,json:any) => {
  try{
    const ext = meta.name.split('.').pop();
    return await bizfile(url,json,meta.name,ext,meta.type);
  }
  catch(err){
    return Promise.reject(err);
  }
};

export const getpdf = async (params:any,name:string,data:any,record:any) =>{
  try{
    const {docid = '001'} = data||{};
    var filename = name||'scsms_report_'+docid+'.pdf';
    const response = await bizpdf('/biz/pdf',params,filename);
    var blob = new Blob([response], {type: "application/pdf"});
    saveAs(blob, filename);
  }
  catch(error){
    console.log('pdferror',error);
    return Promise.reject(error);
  }
};

export const getcsv = async (params:any,name:string,data:any,record:any) =>{
  try{
    const {docid = '001'} = data||{};
    var filename = name||'scsms_report_'+docid+'.csv';
    const response = await bizpdf('/biz/pdf',params,filename);
    var blob = new Blob([response], {type: "application/csv"}); //new Blob([JSON.stringify(recordset)], {type: "application/json;charset=utf-8"});
    saveAs(blob, filename);
  }
  catch(error){
    console.log('pdferror',error);
    return Promise.reject(error);
  }
};

export const downloadFile = async (mode:string,params:any,name:string,data:any,record:any) =>{
  try{
    var filename = `scsms_report_${name}.${mode}`;
    var path = `/biz/print/${mode}`;
    var meta = {
      name: filename,
      ctype: `application/${mode}`,
      type: `application/${mode}`
    };
    
    return await bizdownload(meta,path,params);
  }
  catch(error){
    console.log("Print Error ",error);
    return Promise.reject(error);
  }
};

export const bizupload = async (type:string,params:any,name?:string,extra?:any,record?:any) => {
  try{
    const url = `/biz/file/${type}`;

    const formData:any = new FormData();
    
    for(let key in params){
      const val = params[key];
      if(val instanceof File){
        const {name:filename} = val;
        formData.append('file', val, filename);
        formData.append(key,filename);
      }
      else{
        formData.append(key,val);
      }
      
    }

    const config:any = getFormConfig();
    config.body = formData._blob ? formData._blob() : formData;

    const resp = await fetch(url,config);
    const response = await resp.json();
    const {error,data} = processResponse(response);

    if(error) {
      return Promise.reject(data);
    }
    else {
      return data;
    }

  }
  catch(err){
    console.log('bizupload.error: ',err);
    return Promise.reject(err);
  }
};

////

export const formsubmit = async(url:string,form:any,bp:any) => {
  const fn = (fd:any) => {
    for(let key in bp){
      fd.append(key,bp[key]);
    }
    return fd;
  };

  try{
    const config = getFormConfig();
    return await basesubmit(url,form,config,fn);
  }
  catch(err){
    const error:any  = err || {};
    console.log('formsubmit error:'+error.message);
    var rtn = {failure:true,title:error.title,type:error.type,mesg:error.message,data:null};
    return Promise.reject(rtn);
  }
};

export const filesubmit = async(url:string,form:any) => {
  try{
    const config = getFormConfig();
    return await basesubmit(url,form,config);
  }
  catch(err){
    const error:any  = err || {};
    console.log('formsubmit error:'+error.message);
    var rtn = {failure:true,title:error.title,type:error.type,mesg:error.message,data:null};
    return Promise.reject(rtn);
  }
};

export const datasubmit = async(url:string,json:any) => {
  try{
    const config:any = {
      method:'POST',
      credentials:'include',
      body:JSON.stringify(json), 
      headers: new Headers({
        'Content-Type': 'application/json', 
        'Accept': 'application/json'
      })
    };
    const resp = await fetch(url,config);
    const response = await resp.json();
    const {error,data} = processResponse(response);
    if(error) return Promise.reject(data);
    else return data;
  }
  catch(err){
    return Promise.reject(err);
  }
};

const bizrequest = {jsonpost,bizpost,bizfile,bizpdf,bizzip,bizdownload,downloadFile,formsubmit,filesubmit,datasubmit};
export default bizrequest;
